import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types/api';
import { MembershipCancelReason } from './MembershipCancelReasonsService';

const URL = '/v2/sitter-membership-cancel-reasons';

class SitterMembershipCancelReasonsService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<MembershipCancelReason>> {
    return axios.get(URL, config);
  }
}

export { SitterMembershipCancelReasonsService };
